// src/components/HowItWorks.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../style/HowItWorks.css';
import { useI18n } from '../i18n/I18nContext';

const HowItWorks = () => {
  const { t } = useI18n();
  const steps = t('how.steps');
  return (
  <section className="how-it-works-container">
    <div className="section-heading">
      <p className="eyebrow">{t('how.eyebrow')}</p>
      <h2>{t('how.title')}</h2>
      <p>{t('how.body')}</p>
    </div>
    <div className="how-it-works-steps">
      {steps.map(([title, body], index) => (
        <article className="step" key={title}>
          <span className="step-number">{String(index + 1).padStart(2, '0')}</span>
          <h3>{title}</h3>
          <p>{body}</p>
        </article>
      ))}
    </div>
    <aside className="marketplace-payment-boundary">
      <div>
        <span>{t('how.boundary')}</span>
        <h3>{t('how.boundaryTitle')}</h3>
      </div>
      <p>
        {t('how.boundaryBody')} <Link to="/terms">{t('how.terms')} →</Link>
      </p>
    </aside>
  </section>
  );
};

export default HowItWorks;
